module.exports = __webpack_public_path__ + "static/img/homeProduct3.c0935666.png";